import React, { Component } from "react";
import "./Header.css";
import logo from "../../logo.png";
import { toPersianNumber } from "../../classes/utils";

import withRouter from "../withRouter/withRouter";
import noImg from "../../no-image.png";

class Header extends Component {
    constructor(props) {
        super(props);
        this.search = this.search.bind(this);
    }

    search(searchText) {
        let { router } = this.props;

        searchText = searchText.replaceAll("&", "");
        searchText = searchText.replaceAll(" ", "");
        searchText = searchText.replaceAll("|", "");
        searchText = searchText.replaceAll("=", "");
        searchText = searchText.replaceAll(";", "");
        searchText = searchText.replaceAll("+", "");
        searchText = searchText.replaceAll("-", "");
        searchText = searchText.replaceAll("?", "");
        searchText = searchText.replaceAll("؟", "");
        searchText = searchText.replaceAll("$", "");
        searchText = searchText.replaceAll("#", "");
        searchText = searchText.replaceAll("!", "");
        searchText = searchText.replaceAll('"', "");
        searchText = searchText.replaceAll("'", "");
        searchText = searchText.replaceAll("(", "");
        searchText = searchText.replaceAll(")", "");
        searchText = searchText.replaceAll("}", "");
        searchText = searchText.replaceAll("{", "");
        searchText = searchText.replaceAll("/", "");
        searchText = searchText.replaceAll("\\", "");
        searchText = searchText.replaceAll(".", "");
        searchText = searchText
            .split(" ")
            .filter((p) => {
                return p != "";
            })
            .join("+");

        searchText.length > 0 &&
            router.navigate(`/search?search=${searchText}`);
    }

    state = { costumer: null };
    render() {
        let currentPage = this.props.router.location.pathname;
        let { costumer, deleteFromCart, showSearch } = this.props;
        let cart = costumer && costumer.cart;
        let searchText = "";
        return (
            <div className={"Header"}>
                <div
                    className={
                        "cart " +
                        ((!cart || (cart && cart.length === 0)) && "empty")
                    }
                >
                    <div className="icon">
                        <i className="ri-shopping-cart-2-line"></i>
                        <div
                            className={
                                "count " +
                                ((!cart || (cart && cart.length === 0)) &&
                                    "empty")
                            }
                        >
                            {cart ? cart.length || 0 : 0}
                        </div>
                    </div>
                    {cart && cart.length > 0 && (
                        <div className="list">
                            {cart.map((item, index) => {
                                let {
                                    thumbnail,
                                    name,
                                    color,
                                    amount,
                                    unit,
                                    id,
                                } = item;
                                !thumbnail && ( thumbnail = {url:noImg})
                                return (
                                    <div className="item" key={index}>
                                        <img src={thumbnail.url} alt={name} />
                                        <a className="name" href={"/item/" + id}>
                                            {name}
                                        </a>
                                        <div
                                            className="color"
                                            style={{
                                                backgroundColor: color.color,
                                            }}
                                        ></div>
                                        <div className="amount">
                                            {`${toPersianNumber(
                                                parseFloat(amount)
                                            )}  ${unit}`}
                                        </div>
                                        <div
                                            className="delete"
                                            onClick={(ev) => {
                                                deleteFromCart &&
                                                    deleteFromCart(index);
                                            }}
                                        >
                                            <i className="ri-close-circle-line text danger"></i>
                                        </div>
                                    </div>
                                );
                            })}
                            <div className="checkout">
                                <button className="btn confirm">
                                    <a href="/checkout">تکمیل کردن سفارش</a>
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                <div className="center">
                    <div className="top">
                        <a href="/" id="home">
                            صفحه اصلی
                        </a>
                        <a
                            href={
                                costumer.signed
                                    ? "/costumer"
                                    : "/register" +
                                      (currentPage !== "/" ? currentPage : "")
                            }
                        >
                            <i className="ri-user-3-fill"></i>
                            {costumer.signed ? " پنل مشتری" : " ورود / عضویت"}
                        </a>

                        <a href="/follow-up" id="orderTracking">
                            <i className="fa-solid fa-truck-fast"></i>
                            پیگیری سفارش
                        </a>

                        <a
                            href="https://tracking.post.ir/"
                            className="postal_tracking"
                            target="__blank"
                        >
                            <i className="fa-solid fa-map-location-dot"></i>
                            رهگیری پستی
                        </a>
                        <a href="/pay/offline" id="orderTracking">
                            <i className="fa-solid fa-file-invoice-dollar"></i>
                            ثبت فیش واریز
                        </a>
                        <a href="/rules" id="rules">
                            <i className="fa-solid fa-scale-balanced"></i>
                            قوانین سایت
                        </a>
                        <a href="/about-us" id="about">
                            <i className="ri-information-line"></i>
                            درباره ما
                        </a>
                        {costumer.signed && (
                            <a
                                className="exit text danger"
                                onClick={this.props.logout}
                            >
                                <i className="fa-solid fa-arrow-up-right-from-square"></i>
                            </a>
                        )}
                    </div>
                    <div className="bottom">
                        {showSearch && (
                            <div className="search">
                                <input
                                    type="text"
                                    name="search"
                                    id="search"
                                    placeholder="اینجا جستجو کنید"
                                    onChange={(ev) => {
                                        searchText = ev.target.value;
                                    }}
                                />
                                <button
                                    className="searchBtn btn confirm"
                                    onClick={(ev) => {
                                        this.search(searchText);
                                    }}
                                >
                                    جستجو
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                <div className="left">
                    <div className="logo">
                        <div className="siteName">
                            <div> خرازی اینترنتی </div>
                            <div>نیکا </div>
                        </div>
                        <img src={logo} alt="" srcSet="" />
                    </div>
                </div>

                <div className="responsiveMenu">
                    <div className="menu">
                        <i className="ri-menu-3-fill"></i>
                        <input type="checkbox" />
                        <div className="menuPage">
                            <div className="logo">
                                <img src={logo} alt="" srcSet="" />
                                <div className="siteName">
                                    <div> خرازی اینترنتی نیکا </div>
                                </div>
                            </div>
                            <a href="/" id="home">
                                <i className="ri-home-3-line"></i>
                                صفحه اصلی
                            </a>
                            <a
                                href={
                                    costumer.signed
                                        ? "/costumer"
                                        : "/register" +
                                          (currentPage !== "/"
                                              ? currentPage
                                              : "")
                                }
                            >
                                <i className="ri-user-3-fill"></i>
                                {costumer.signed
                                    ? " پنل مشتری"
                                    : " ورود / عضویت"}
                            </a>

                            <a href="/follow-up" id="orderTracking">
                                <i className="fa-solid fa-truck-fast"></i>
                                پیگیری سفارش
                            </a>

                            <a
                                href="https://tracking.post.ir/"
                                className="postal_tracking"
                            >
                                <i className="fa-solid fa-map-location-dot"></i>
                                رهگیری پستی
                            </a>
                            <a href="/pay/offline" id="orderTracking">
                                <i className="fa-solid fa-file-invoice-dollar"></i>
                                ثبت فیش واریز
                            </a>
                            <a href="/rules" id="rules">
                                <i className="fa-solid fa-scale-balanced"></i>
                                قوانین سایت
                            </a>
                            <a href="/about-us" id="about">
                                <i className="ri-information-line"></i>
                                درباره ما
                            </a>
                            {costumer.signed && (
                                <a
                                    className="exit text danger"
                                    onClick={this.props.logout}
                                >
                                    <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                </a>
                            )}
                        </div>
                    </div>
                    <a href="/search" className="search">
                        <i className="ri-search-2-line"></i>
                    </a>
                    <a href="/checkout" className="cart">
                        <i className="ri-shopping-cart-2-line"></i>
                        <div
                            className={
                                "count " +
                                ((!cart || (cart && cart.length === 0)) &&
                                    "empty")
                            }
                        >
                            {cart ? cart.length || 0 : 0}
                        </div>
                    </a>
                    <a href="/costumer" className="account">
                        <i className="ri-user-3-line"></i>
                    </a>
                    <a href="/" className="home">
                        <i className="ri-home-3-line"></i>
                    </a>
                </div>
            </div>
        );
    }
}

export default withRouter(Header);
